import {
  addDays,
  endOfDay,
  endOfYesterday,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfYear,
} from 'date-fns';

export const predefinedRanges = [
  {
    key: 'Custom',
    value: 0,
    func: () => ({}),
  },
  {
    key: 'Last 7 days',
    value: 1,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfDay(addDays(end, -7)),
        end: end,
      };
    },
  },
  {
    key: 'Last 14 days',
    value: 2,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfDay(addDays(end, -14)),
        end: end,
      };
    },
  },
  {
    key: 'Last 30 days',
    value: 3,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfDay(addDays(end, -30)),
        end: end,
      };
    },
  },
  {
    key: 'Last Month',
    value: 4,
    func: today => {
      const end = addDays(startOfMonth(today), -1);

      return {
        start: startOfMonth(end),
        end: endOfDay(end),
      };
    },
  },
  {
    key: 'Last Quarter',
    value: 5,
    func: today => {
      const end = addDays(startOfQuarter(today), -1);

      return {
        start: startOfQuarter(end),
        end: endOfDay(end),
      };
    },
  },
  {
    key: 'Last Year',
    value: 6,
    func: today => {
      const end = addDays(startOfYear(today), -1);

      return {
        start: startOfYear(end),
        end: endOfDay(end),
      };
    },
  },
  {
    key: 'Month to date',
    value: 7,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfMonth(end),
        end: end,
      };
    },
  },
  {
    key: 'Current quarter',
    value: 8,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfQuarter(end),
        end: end,
      };
    },
  },
  {
    key: 'Year to date',
    value: 9,
    func: _ => {
      const end = endOfYesterday();

      return {
        start: startOfYear(end),
        end: end,
      };
    },
  },
];
